import { Component, Input } from '@angular/core';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-upload-event',
  templateUrl: './upload-event.component.html'
})

export class ASUploadEventComponent extends WithDisposableSubject()  {

  @Input() item: SearchActivityEvents.Node;

  /**
   *
   */
  constructor(
  ) {
    super();
  }


}
